/**
 * graphJson 의 색 값(`var(--color-map-*)`, hex, rgb, named, 'none')을 Canvas 에서
 * 쓸 수 있는 실제 색 문자열로 1회 해석하고 캐시한다.
 *
 * SVG(JointJS)는 CSS 변수를 그대로 칠하지만 Canvas 2D 는 `var(...)` 를 모른다.
 * `ctx.fillStyle = 'var(--x)'` 는 무효 대입이라 무시되고 직전 색(보통 검정)으로
 * 칠해진다 — 도면이 전부 검게 보이던 원인. 숨겨진 probe 엘리먼트에 color 로 대입한
 * 뒤 getComputedStyle 로 해석하면 모든 형태를 rgb() 로 일관 변환할 수 있다.
 */

const cache = new Map<string, string | undefined>();
let probe: HTMLSpanElement | null = null;

function getProbe(): HTMLSpanElement {
  if (!probe) {
    probe = document.createElement('span');
    probe.style.display = 'none';
    document.body.appendChild(probe);
  }
  return probe;
}

/** 색 값 → Canvas 용 색 문자열. 칠하지 않아야 하면(none/transparent/빈값) undefined. */
export function resolveColor(value: string | undefined): string | undefined {
  if (!value || value === 'none' || value === 'transparent') return undefined;
  if (cache.has(value)) return cache.get(value);

  const el = getProbe();
  el.style.color = '';
  el.style.color = value;
  const resolved = getComputedStyle(el).color;
  const out = resolved && resolved !== '' ? resolved : value;
  cache.set(value, out);
  return out;
}

/** 테마 변경 등으로 토큰 값이 바뀌면 호출 — 다음 해석부터 재계산한다. */
export function clearColorCache(): void {
  cache.clear();
}
